import { DocumentNode, gql } from '@apollo/client';

export const TableDatabaseNameFragmentGql: DocumentNode = gql`
fragment TableDatabaseName on Table {
  __typename
  ... on DatabaseTable {
    vizportalId
    database {
      name
      isGrouped
      ... on DatabaseServer {
        hostName
      }
      ... on File {
        filePath
      }
    }
  }
}
`;
